<h3>{{ 'TROUBLESHOOTING' | translate }}</h3>

<lib-gung-tabset #ngbTab="gungTabset" orientation="vertical">
  @for (tab of gungTroubleshootingMenu; track tab.id) {
    <lib-gung-tab [id]="tab.id">
      <ng-template libGungTabTitle>
        <div class="tab-title">
          <i *ngIf="tab.icon" [class]="tab.icon"></i>
          <span>{{ tab.name | translate }}</span>
        </div>
      </ng-template>
      <ng-template libGungTabContent>
        <div class="row">
          <div class="col-12">
            <ng-container *ngComponentOutlet="tab.component"></ng-container>
          </div>
        </div>
      </ng-template>
    </lib-gung-tab>
  }
</lib-gung-tabset>
